import React from 'react';
import {
  Tooltip,
  FormGroup,
  FormControlLabel,
  Checkbox,
  Divider,
  FormControl,
  FormLabel,
  RadioGroup,
  Radio,
} from '@mui/material';

const CharacterOptions = ({
  canManageEnemies,
  isEnemy,
  setIsEnemy,
  isLarge,
  setIsLarge,
  isPc,
  setIsPc,
}) => {
  return (
    <>
      <Divider sx={{ my: 1 }}>Options</Divider>
      <FormGroup sx={{ flexDirection: 'row', gap: 2, justifyContent: 'center', flexWrap: 'wrap' }}>
        <Tooltip
          title={!canManageEnemies ? 'Only the DM can create enemy coins' : ''}
          arrow
        >
          <FormControlLabel
            control={
              <Checkbox
                checked={isEnemy}
                onChange={(e) => setIsEnemy(e.target.checked)}
                disabled={!canManageEnemies}
              />
            }
            label="Enemy"
          />
        </Tooltip>
        <FormControlLabel
          control={
            <Checkbox
              checked={isLarge}
              onChange={(e) => setIsLarge(e.target.checked)}
            />
          }
          label="Large (2x2)"
        />
      </FormGroup>
      {!isEnemy && setIsPc && (
        <>
          <FormControl component="fieldset" sx={{ mt: 1, width: '100%' }} variant="standard">
            <RadioGroup
              row
              value={isPc ? 'player' : 'npc'}
              onChange={(e) => setIsPc(e.target.value === 'player')}
              sx={{ justifyContent: 'center' }}
            >
              <FormControlLabel value="player" control={<Radio size="small" />} label="Player" />
              <FormControlLabel value="npc" control={<Radio size="small" />} label="NPC" />
            </RadioGroup>
          </FormControl>
        </>
      )}
    </>
  );
};

export default CharacterOptions;
